import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import axios from 'axios';
import Cookies from 'js-cookie';

import scrollSpy, { AnchorTarget } from 'jbc-front/components/ScrollSpy';
import ListGroup from 'jbc-front/components/ListGroup';
import Affix from 'jbc-front/components/Affix';

import { REDUCER_NAME } from 'src/reducers/clients/clients';
import { CLIENT_EDIT, CLIENT_SHOW, CLIENT_SETTINGS, JBC_LMS_CLIENT_IMPORT, COMPANY_NEW } from 'src/constants/EndpointUrls';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { setItem } from 'src/reducers/common/itemReducer';
import { NextAndPrevRecordButton, Anchor } from 'src/components';
import { Panel, Headding, Item } from 'src/components/PrimaryPanel';
import Button from 'jbc-front/components/Button';
import { Edit, Link, Pulldown } from 'jbc-front/components/icons';
import Balloon from 'src/features/Employees/components/Balloon';
import FreePlanRestriction from 'src/components/FreePlanRestriction';
import { isFreePlan } from 'src/reducers/clients/currentClient';
import UnsyncModal from 'src/components/UnsyncModal';

import { useTranslation, withTranslation } from 'react-i18next';

import ImportFromRoumuModal from './components/ImportFromRoumuModal';
import BasicInfoSectionShow from './components/BasicInfoSectionShow';
import BranchInfoSectionShow from "./components/BranchInfoSectionShow";
import TaxIncomeSectionShow from './components/TaxIncomeSectionShow';
import LabourConsultantSectionShow from './components/LabourConsultantSectionShow';
import BanksSectionShowContainer from './containers/BankSectionShowContainer';
import styles from './ShowClient.scss';
// import { withTranslation } from 'react-i18next';
import i18next from 'i18next';
// @TODO: Hide Provident Fund for Vietnam - comment out unused import
// https://donuts-vn.atlassian.net/browse/JBC-25
// import ProvidentFundSectionShowContainer from "./containers/ProvidentFundSectionShowContainer"
import ImageSectionShow from './containers/ImageSectionShow'
const syncsWithLms = () => Cookies.get('using_jbc_lms') === 'true';


const ClientSideNavi = ({ current }) => {
  const { t, i18n } = useTranslation();
  return (
    <div className="l-flex6-sub">
      <Affix offset={209} className={styles.sideNavi}>
        <ListGroup>
          <Anchor name="OfficeInfomation" current={current}>
            {t('features.Settings.Settings.office_information')}
          </Anchor>
          <Anchor name="BranchInfomation" current={current}>
            {t('features.Clients.components.BranchInfoSectionShow.branch_information')}
          </Anchor>
          <Anchor name="TransferSourseAccoutInformation" current={current}>
            {t('features.Clients.ShowClient.transfer_source_account_information')}
          </Anchor>
          {/* @TODO: Hide Provident Fund for Vietnam */}
          {/* https://donuts-vn.atlassian.net/browse/JBC-25 */}
          {/*
          <Anchor name="ProvidentFundInformation" current={current}>
            {t('features.Clients.ShowClient.provident_fund_setting')}
          </Anchor>
          */}
          <Anchor name="ClientPhoto" current={current}>
            {t('features.Clients.components.ImageSection.client_photo')}
          </Anchor>
        </ListGroup>
      </Affix>
    </div>
  );
};

const ClientMainContent = ({ editUrl, planType }) => {

  const [ isClientCoordinationBaloonOpen, setIsClientCoordinationBaloonOpen ] = React.useState(false);
  const [ isImportModalOpen, setIsImportModalOpen ] = React.useState(false);

    return (
      <div className="l-flex6-main">
        <div>

          {/* <div className={styles.buttonWrap}>
            <div className={styles.button}>
              <Button
                onClick={() =>
                  this.setState({
                    isClientCoordinationBaloonOpen: !this.state.isClientCoordinationBaloonOpen,
                    isEmployeeAddBaloonOpen: false
                  })
                }
                className="ignore-react-onclickoutside"
                icon={<Link size={17} />}
                disabled={isFreePlan(planType)}
                disabledReason={isFreePlan(planType) ? <FreePlanRestriction /> : null}
                widthAuto
              >
                {i18next.t('features.Employees.EmployeeList.link')}
              </Button>
              {this.state.isClientCoordinationBaloonOpen && (
                <Balloon hide={() => this.setState({ isClientCoordinationBaloonOpen: false })} right>
                  <ul className={styles.links} style={{ cursor: 'pointer' }}>
                    <li
                      role="presentation"
                      onClick={e => {
                        e.stopPropagation();
                        this.setState({ ...this.state, isImportModalOpen: true, isClientCoordinationBaloonOpen: true });
                      }}
                    >
                      <span>
                        <Pulldown size={8} />{i18next.t('features.Clients.ShowClient.obtained_from_JOBCAN_Labor_Management')}
                      </span>
                    </li>
                    <li>
                      <a
                        href="https://jobcan-payroll.zendesk.com/hc/ja/articles/360006242673#Contents2"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        <Pulldown size={8} />{i18next.t('features.Employees.EmployeeList.check_link_items')}
                      </a>
                    </li>
                  </ul>
                </Balloon>
              )}
            </div>
          </div> */}
          <Panel>
            <AnchorTarget name="OfficeInfomation" />
              <Headding icon={<a href={editUrl}><Edit icon={16} /></a>}>{i18next.t('features.Settings.Settings.office_information')}</Headding>
              <BasicInfoSectionShow />
          </Panel>

          <Panel>
          <AnchorTarget name="BranchInfomation" />
              <Headding icon={<a href={editUrl}><Edit icon={16} /></a>}>{i18next.t('features.Clients.components.BranchInfoSectionShow.branch_information')}</Headding>
              <BranchInfoSectionShow />
          </Panel>

          {/* <Panel>
            <a href={editUrl}>
              <Headding icon={<Edit icon={16} />}>{i18next.t('features.Clients.components.TaxIncome.Client_tax_income')}</Headding>
            </a>
            <TaxIncomeSectionShow />
          </Panel> */}
          {/* <Panel>
            <a href={editUrl}>
              <Headding icon={<Edit icon={16} />}>{i18next.t('features.Clients.ShowClient.certified_labor_consultant_information')}</Headding>
            </a>
            <LabourConsultantSectionShow />
          </Panel> */}
          <Panel>
            <AnchorTarget name="TransferSourseAccoutInformation" />
              <Headding icon={<a href={editUrl}><Edit icon={16} /></a>}>{i18next.t('features.Clients.ShowClient.transfer_source_account_information')}</Headding>
              <BanksSectionShowContainer />
          </Panel>

          {/* @TODO: Hide Provident Fund for Vietnam */}
          {/* https://donuts-vn.atlassian.net/browse/JBC-25 */}
          {/*
            <Panel>
              <AnchorTarget name="ProvidentFundInformation" />
              <Headding icon={<a href={editUrl}><Edit icon={16} /></a>}>
                {i18next.t('features.Clients.ShowClient.provident_fund_setting')}
              </Headding>
              <ProvidentFundSectionShowContainer />
            </Panel>
          */}

          <Panel>
            <AnchorTarget name="ClientPhoto" />
              <Headding icon={<a href={editUrl}><Edit icon={16} /></a>}>{i18next.t('features.Clients.components.ImageSection.client_photo')}</Headding>
              <ImageSectionShow />
          </Panel>

        </div>
        {syncsWithLms() ? (
          <ImportFromRoumuModal
            isOpen={isImportModalOpen}
            hideModal={() =>{
              setIsClientCoordinationBaloonOpen(true);
              setIsImportModalOpen(false);
              }
            }
            onSubmit={() => axios.post(JBC_LMS_CLIENT_IMPORT)}
          />
        ) : (
          <UnsyncModal
            isOpen={isImportModalOpen}
            hideModal={() =>{
              setIsClientCoordinationBaloonOpen(true);
              setIsImportModalOpen(false);
              }
            }
          />
        )}
      </div>
    );
}

const ShowClientView = scrollSpy(
  ({ editUrl, planType, current, companies, options }) => {
    const { t } = useTranslation();
    return (
      <div>
        <div className={`${styles.wrap} l-wrap-xl l-contents-wrap`}>
          <div className="u-mb20">
            <BreadCrumb>
              <BreadCrumb.Item label={t('components.SideMenu.SideMenu.setting')} path={CLIENT_SETTINGS} />
              <BreadCrumb.Item label={t('features.Settings.Settings.office_information')} />
            </BreadCrumb>
          </div>
        </div>

        <div className={styles.head}>
          <div className={styles.name}>{i18next.t('features.Settings.Settings.office_information')}</div>
        </div>

        {companies.length === 0 && options.isDisplayGroupCompanySetting === "enable" &&
          <div className={`${styles.buttonWrap} l-wrap-xl l-contents-wrap`}>
            <div className={styles.button}>
              <Button href={COMPANY_NEW} as="a" primary>
                {t('features.Clients.ShowClient.register_new_office')}
              </Button>
            </div>
          </div>
        }

        <div className="l-flex">
          <ClientSideNavi {...{ current }} />
          <ClientMainContent {...{ editUrl, planType }} />
        </div>
      </div>
    )
  }
);

const ShowClient = ({ dispatch, values, planType }) => {
  dispatch(setItem(REDUCER_NAME, values));
  const editUrl = CLIENT_EDIT;
  const companies = values.companies;
  const options = values.options;
  return <ShowClientView
            { ...{editUrl, planType, companies, options } }
        />;
};

export default withTranslation()(connect(state => ({
  planType: _.get(state, 'currentClient.item.data.planType')
}))(ShowClient));
